import { apiUrl } from "../config/environment";
import i18n from "../i18n";
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}
export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const res = await fetch(apiUrl(path), {
    credentials: "include",
    ...options,
    headers: {
      "Accept-Language": i18n.resolvedLanguage || "en",
      ...(options.body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...options.headers,
    },
  }).catch((error: Error) => {
    if (error.name === "AbortError") throw error;
    throw new ApiError(0, "Unable to connect. Please try again.");
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 401 && !path.startsWith("/auth/"))
      window.dispatchEvent(new Event("session-expired"));
    throw new ApiError(
      res.status,
      body.code === "VALIDATION_ERROR" && i18n.resolvedLanguage === "fr"
        ? "Please check the form fields and try again."
        : body.message || "Unable to connect. Please try again.",
    );
  }
  return res.status === 204 ? (undefined as T) : res.json();
}
export const saveRecord = (path: string, data: unknown, id?: string) =>
  api(path + (id ? "/" + id : ""), {
    method: id ? "PATCH" : "POST",
    body: JSON.stringify(data),
  });
export async function uploadFile(
  file: File,
  scope: string,
): Promise<{ id: string; name: string }> {
  const body = new FormData();
  body.append("file", file);
  return api("/files/" + scope, { method: "POST", body });
}
